import { endContract } from "api/Employee";
import { useMutation } from "react-query";
import { toast } from "react-toastify";


export const useEndContract = () => {
    return useMutation(endContract, {
        onSuccess: () => {
            toast.success("Contract ended successfully!");
        },
        onError: () => {
            toast.error("Something went wrong! Please try again later.");
        },
    })
}